import React from 'react';
import { MediaDeviceMenu, DisconnectButton } from '@livekit/components-react';

export default function CustomControlBar({ onLeave}) {
  return (
    <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 16 }}>
      <MediaDeviceMenu>
        <span style={{ fontWeight: 600 }}>Einstellungen</span>
      </MediaDeviceMenu>
      <DisconnectButton onClick={onLeave}>
        <span style={{ fontWeight: 600 }}>Beenden</span>
      </DisconnectButton>
    </div>
  );
}
